<template>
    <div class="MacSetIndex" v-if="permisShow('电脑端-机器认证查看')||permisShow('移动端-机器认证查看')">
        <div class="tab">
            <div class="tab-item" v-if="permisShow('电脑端-机器认证查看')" :class="pcOrPhone=='macSet'?'tab-active':''" @click="setComponent('macSet')">电脑端</div>
            <div class="tab-item" v-if="permisShow('移动端-机器认证查看')" :class="pcOrPhone=='phoneMacSet'?'tab-active':''" @click="setComponent('phoneMacSet')">移动端</div>
            
        </div>
        <component :is="pcOrPhone" />
    </div>
</template>

<script>
import macSet from "./macSet";
import phoneMacSet from "./phoneMacSet";
export default {
    components: {
        macSet: macSet,
        phoneMacSet: phoneMacSet,
    },
    data(){
        let permisList = JSON.parse(sessionStorage.getItem("permisList"));
        return {
            permisList,
            pcOrPhone: ''
        }
    },
    mounted(){
        let activeTab = sessionStorage.getItem('pcOrPhone')||''
        if(activeTab){
            this.pcOrPhon = activeTab==1?'macSet':'phoneMacSet'
        }
        if(this.permisShow('电脑端-机器认证查看')){
            this.pcOrPhone = 'macSet'
            console.log(123)
        }
        else if(this.permisShow('移动端-机器认证查看')){
            this.pcOrPhone = 'phoneMacSet'
        }else{
            this.pcOrPhone = ''
        }
    },
    methods: {
        permisShow(data) {
            // 权限配置
            let result = this.permisList.indexOf(data);
            console.log(23432343423, result);
            if (result >= 0) {
                return true;
            } else {
                return false;
            }
        },
        setComponent(data){
            this.pcOrPhone = data
            console.log(123, this.pcOrPhone)
        }
    }
};
</script>

<style lang="less">
.MacSetIndex {
    background: #ffffff;
    margin: 20px 18px;
    padding: 22px 30px 10px;
    .tab {
        display: flex;
        align-items: center;
        &-item {
            width: 100px;
            height: 36px;
            font-size: 14px;
            line-height: 36px;
            background: #f1f1f1;
            text-align: center;
            cursor: pointer;
        }
        &-active {
            background: #ff9065;
            color: #ffffff;
        }
    }
}
</style>